// Shared connector values used by Settings and MCP-first onboarding.
//
// The endpoint follows whichever environment the app is running in. Hardcoding
// production meant the staging and dev apps handed users a connector pointing
// at PRODUCTION — connecting a test session to real customer data, and making
// the connector itself untestable outside prod. Same class of leak as GH-164.
import { defaultBaseURL } from '../services/api/client.js';

export const MCP_ENDPOINT_URL = `${defaultBaseURL().replace(/\/$/, '')}/mcp`;
export const CLAUDE_INSTALL_URL = `https://claude.ai/customize/connectors?modal=add-custom-connector&connectorName=Dathent&connectorUrl=${encodeURIComponent(MCP_ENDPOINT_URL)}`;
export const CLAUDE_CODE_COMMAND = `claude mcp add --transport http dathent ${MCP_ENDPOINT_URL}`;
export const CODEX_ADD_COMMAND = `codex mcp add dathent --url ${MCP_ENDPOINT_URL}`;
export const CODEX_LOGIN_COMMAND = 'codex mcp login dathent';
// ChatGPT app directory listing — approved 2026-08-19. This replaces the
// Developer-mode / paste-the-URL route for ordinary ChatGPT users: they open
// this link (or search "Dathent" in ChatGPT's app directory) and connect in one
// click. The Developer-mode and Codex CLI paths stay documented for people who
// want the raw MCP endpoint. Claude.ai has no equivalent directory — its manual
// CLAUDE_INSTALL_URL flow above is still the only way in.
export const CHATGPT_APP_URL = 'https://chatgpt.com/plugins/plugin_asdk_app_6a6172c418e481918bf3817aa288e3f0';

export const MCP_ONBOARDING_CHOICE_KEY = 'dathent.mcponb.choice';
export const MCP_ONBOARDING_STARTED_KEY = 'dathent.mcponb.startedAt';
export const MCP_ONBOARDING_HANDOFF_DONE_KEY = 'dathent.mcponb.handoff.done';
export const MCP_STARTER_PROMPT = 'Finish setting up my Dathent account — scan my website and build my first content plan.';

export function readMcpOnboardingChoice() {
  try {
    const choice = window.localStorage.getItem(MCP_ONBOARDING_CHOICE_KEY);
    return choice === 'ui' || choice === 'ai' ? choice : null;
  } catch (_) {
    return null;
  }
}

export function writeMcpOnboardingChoice(choice) {
  try {
    window.localStorage.setItem(MCP_ONBOARDING_CHOICE_KEY, choice);
    if (choice === 'ai') {
      window.localStorage.setItem(MCP_ONBOARDING_STARTED_KEY, String(Date.now()));
      window.localStorage.removeItem(MCP_ONBOARDING_HANDOFF_DONE_KEY);
    } else {
      window.localStorage.removeItem(MCP_ONBOARDING_STARTED_KEY);
    }
  } catch (_) { /* private mode */ }
}
